<div class="block-holder">
  <div
    *ngFor="let user of blockedUsers; let i = index"
    class="user-box"
    [ngStyle]="{ 'margin-top': i === 0 ? '16px' : '0' }"
  >
    <img
      *ngIf="user.avatarPath !== ''"
      src="{{ user.avatarPath }}"
      onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
      class="user-img"
      (click)="profile(user.userName)"
    />
    <img
      *ngIf="user.avatarPath === ''"
      src="assets/blog/avatar.svg"
      class="user-img"
      (click)="profile(user.userName)"
    />
    <div class="user-box-username" (click)="profile(user.userName)">
      {{ user.userName }}
    </div>
    <div class="unblock-box" (click)="unBlock(user)">آنبلاک</div>
  </div>
  <div *ngIf="blockedUsers.length === 0" class="empty-list">
    کاربری موجود نیست
  </div>
</div>
